import Vue from 'vue'
import router from '@/router'

function LoggerEngine () {
  const that = this

  this.logTypes = {
    vueError: 'vueError',
    vueWarn: 'vueWarn',
    apiError: 'apiError',
    globalError: 'globalError'
  }

  this.logEndPointUrl = '/global/logger/send'

  this.methods = {
    vueError (err, info) {
      console.info('[Logger - vueError]', err, info)
      that.logPush(that.logTypes.vueError, { err, info })
    },
    vueWarn (msg, trace) {
      console.info('[Logger -vueWarn]', msg, trace)
      that.logPush(that.logTypes.vueWarn, { msg, trace })
    },
    windowError (message, source, lineno, colno, error) {
      console.info('[Logger - windowError]', message, source, lineno, colno, error)
      that.logPush(that.logTypes.globalError, { message, source, lineno, colno, error })
    },
    apiError (axiosJSON) {
      if(axiosJSON.message === 'Canceled') return
      console.info('[Logger - apiError]', axiosJSON.message,
        axiosJSON.config.url, axiosJSON.config.method, axiosJSON.config.params, axiosJSON.config.data)
      if (axiosJSON.config.url !== that.logEndPointUrl) {
        that.logPush(that.logTypes.apiError, axiosJSON)
      }
    },
    getRouterInfo () {
      return router.currentRoute.path
    },
    getEnvInfo () {
      return Vue.prototype.$mainConfig.environment
    },
    getDevice () {
      return {
        userAgent: navigator.userAgent,
        platform: navigator.platform
      }
    },
    getUTCUnixTimestamp () {
      const localDate = new Date() // Yerel zamanı al
      const timezoneOffsetMinutes = localDate.getTimezoneOffset() // Zaman dilimi farkını al
      const utcDateMiliseconds = localDate.getTime() + (timezoneOffsetMinutes * 60 * 1000) // Yerel zamanı UTC'ye çevir
      // Milisaniyeyi saniyeye çevir
      return Math.floor(utcDateMiliseconds / 1000) // UTC zaman damgasını (timestamp) döndür
    },
    getUserName () {
      const userData = localStorage.getItem('userData')

      if (userData) {
        const parsedData = JSON.parse(userData)
        return parsedData.userName || 'NotAvailable'
      } else {
        return 'NotAvailable'
      }
    }
  }

  this.logPush = function (type, data) {
    let logInfo = {
      source: that.methods.getRouterInfo(),
      runtimeEnvironment: that.methods.getEnvInfo(),
      browserInfo: that.methods.getDevice(),
      timestampUTC: that.methods.getUTCUnixTimestamp(),
      userName: that.methods.getUserName(),
      type
    }
    // vueError
    if (type === that.logTypes.vueError) {
      logInfo = {
        ...logInfo,
        trace: data.trace,
        message: data.msg
      }

    // apiError
    } else if (type === that.logTypes.apiError) {
      logInfo = {
        ...logInfo,
        trace: data.config.url,
        message: data.message,
        apiDetails: {
          method: data.config.method,
          params: data.config.params,
          data: data.config.data
        }
      }

    // globalError
    } else if (type === that.logTypes.globalError) {
      logInfo = {
        ...logInfo,
        trace: data.source,
        message: data.message
      }

    // vueWarn
    } else if (type === that.logTypes.vueWarn) {
      console.log('vueWarn', data)
      logInfo = {
        ...logInfo,
        trace: data.trace,
        message: data.msg
      }
    }

    // logPush disabled
    if ((this.methods.getEnvInfo() === 'PROD') && false) {
      Vue.prototype.$http.post(that.logEndPointUrl, logInfo)
        .then(() => {
          console.log('[Logger - logPush] Bir hata gözlemlendi ve kaydedildi.')
        })
        .catch(() => {
          console.log('[Logger - logPush] Bir hata gözlemlendi ve kaydedilemedi.')
        })
    }

    // end of logPush
  }
}

const loggerEngine = new LoggerEngine()

Vue.prototype.$logger = loggerEngine

export default LoggerEngine
